import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class EnhancedBrandContent extends Component {
    #abortController = new AbortController();

    connectedCallback() {
        super.connectedCallback();
        const { signal } = this.#abortController;
        document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    }

    /** @param {CustomEvent} event */
    #handleVariantUpdate = (event) => {
        const html = event.detail.data.html;
        const content = html.querySelector(this.tagName.toLowerCase());
        if (!content) return;
    
        morph(this, content);
    }
}

customElements.define('enhanced-brand-content', EnhancedBrandContent);